module.exports = __webpack_public_path__ + "assets/images/project/thailand-desktop.jpg?v=eae3a680";